<template>
  <div class="col d-flex flex-column text-truncate">
    <font-awesome-icon :icon="['fas', awesome_icon]" :class="to_large_icon ? 'large' : 'normal'" @click="doClick"/>
    <span :class="title_class">
      <slot></slot>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      awesome_icon: {
        type: String,
        default: 'faInfo'
      },
      to_large_icon: {
        type: Boolean,
        default: false
      },
      title_class: {
        type: String,
        default: 'andon-footer-title',
        required: false
      }
    },
    name: "PpExecuteButton",
    methods: {
      doClick() {
        this.$emit('clickIcon')
      }
    }
  }
</script>

<style scoped>
  .normal {
    width: 40px;
    height: 40px;
    color: white;
    margin: 25px auto;
  }

  .large {
    width: 50px;
    height: 50px;
    color: yellow;
    margin: 20px auto;
  }

  .andon-footer-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    margin: auto;
  }
</style>